import React, { useState, useEffect } from "react";
import axios from "axios";
import "./AdminPhotoGallery.css";
import AdminNavbar from "./AdminNavbar";

function AdminPhotoGallery() {
  const [images, setImages] = useState([]);
  const [file, setFile] = useState(null);
  const [title, setTitle] = useState("");
  const [editingImage, setEditingImage] = useState(null);
  const [loadedImages, setLoadedImages] = useState({}); // Track which images are loaded

  useEffect(() => {
    fetchImages();
  }, []);

  const fetchImages = async () => {
    const res = await axios.get("https://himchatterjee.in/backend/get_photo.php");
    setImages(res.data);
    setLoadedImages({}); // Reset loaders on new fetch
  };

  const handleUpload = async (e) => {
    e.preventDefault();
    if (!file || !title) return alert("Please select an image and enter a title!");
    const formData = new FormData();
    formData.append("image", file);
    formData.append("title", title);
    await axios.post("https://himchatterjee.in/backend/add_photo.php", formData);
    setFile(null);
    setTitle("");
    fetchImages();
  };

  const handleDelete = async (id) => {
    await axios.post("https://himchatterjee.in/backend/delete_photo.php", { id });
    fetchImages();
  };

  const handleEditClick = (img) => {
    setEditingImage(img);
    setTitle(img.title);
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    if (!editingImage) return;

    const formData = new FormData();
    formData.append("id", editingImage.id);
    formData.append("title", title);
    if (file) formData.append("image", file);

    await axios.post("https://himchatterjee.in/backend/edit_photo.php", formData);

    setEditingImage(null);
    setFile(null);
    setTitle("");
    fetchImages();
  };

  const handleCancelEdit = () => {
    setEditingImage(null);
    setFile(null);
    setTitle("");
  };

  // When image loads, mark it as loaded
  const handleImageLoad = (id) => {
    setLoadedImages((prev) => ({ ...prev, [id]: true }));
  };

  return (
    <>
      <AdminNavbar />

      <div className="slider-page">
        <div className="notice-box">
          <strong>Note:</strong> Only 9 Photos will be shown in the Photo Gallery. Add only Nine images. 
          Current images: <span className="img-count">{images.length}</span>
        </div>

        {/* Upload / Edit Form */}
        <form onSubmit={editingImage ? handleEditSubmit : handleUpload} className="upload-form">
          <input type="file" onChange={(e) => setFile(e.target.files[0])} />
          <input
            type="text"
            placeholder="Enter Image Title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
          <button type="submit">{editingImage ? "Update Image" : "Add Image"}</button>
          {editingImage && <button type="button" onClick={handleCancelEdit}>Cancel</button>}
        </form>

        {/* Images Table */}
        <table className="images-table">
          <thead>
            <tr>
              <th>Image</th>
              <th>Title</th>
              <th>Option</th>
            </tr>
          </thead>
          <tbody>
            {images.map((img) => (
              <tr key={img.id}>
                <td style={{ position: "relative", width: "80px", height: "80px" }}>
                  {/* Loader show until image loaded */}
                  {!loadedImages[img.id] && (
                    <div className="img-loader"></div>
                  )}
                  <img
                    src={`https://himchatterjee.in/backend/uploads/${img.name}`}
                    alt=""
                    width="80"
                    style={{ display: loadedImages[img.id] ? "block" : "none" }}
                    onLoad={() => handleImageLoad(img.id)}
                  />
                </td>
                <td>{img.title}</td>
                <td>
                  <button className="edit-btn" onClick={() => handleEditClick(img)}>Edit</button>
                  <button className="delete-btn" onClick={() => handleDelete(img.id)}>Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}

export default AdminPhotoGallery;
